<script lang="ts">
  import Mobile from '$components/utils/Mobile.svelte';
  import Text from '$components/utils/Text.svelte';
</script>

<div class="account-number">
  <Text key="page.club.account-number.part1" />
  <Mobile><br /></Mobile>
  <Text key="page.club.account-number.part2.text" />
  <b>
    <Text key="page.club.account-number.part2.number" />
  </b>
</div>

<style lang="scss">
  .account-number {
    padding-top: 27px;
    padding-bottom: 31px;

    margin-top: 60px;

    padding-left: 40px;
    padding-right: 40px;

    background-color: $color-white;

    border-radius: 13px;
    border: 1.5px solid rgba($color-medium-gray, 0.8);

    width: auto;
    align-self: center;
    text-align: center;

    font-weight: 500;
    font-size: 22px;
    line-height: 42px;

    b {
      color: $color-caramel;
    }
  }

  @include mobile {
    .account-number {
      margin-top: 30px;
      margin-bottom: 0;

      width: 90%;

      font-size: 16px;
      line-height: 160%;
    }
  }
</style>
